<template>
  <div
    class="degital-agency-free-mode-wrap agency-free-mode-bg section-space--pt_60 section-space--pb_90"
    id="team"
  >
    <div class="container">
      <div class="digital-agency-section-title-area section-space--mb_60">
        <div class="row">
          <div class="col-lg-6">
            <div class="digital-agency-section-title text-left">
              <h3
                class="section-title font-weight--light mb-15 wow move-up"
                style="color:#2e3280"
              >
                Cloud-native medical devices inside our health platform
              </h3>
            </div>
          </div>
          <div class="col-lg-6 wow move-up">
            <div class="agency-free-mode-button">
              <b-link
                href="https://calendly.com/nichealpham/experiment1et"
                class="ht-btn ht-btn-lg ht-btn--outline mr-3"
              >
                Book a Demo
              </b-link>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 wow move-up">
          <div class="flexible-image-slider-wrap">
            <div
              class="swiper-container auto--per-flexible__container__aegency"
            >
              <div class="swiper-wrapper auto-plexible-row">
                <swiper :options="swiperOption">
                  <div class="swiper-slide">
                    <div class="single-flexible-slider">
                      <img
                        class="img-fluid"
                        src="/p1.png"
                        alt="gallery 01"
                        style="height:400px;border-radius:4px;"
                      />
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="single-flexible-slider">
                      <img
                        class="img-fluid"
                        src="/p2.png"
                        alt="gallery 02"
                        style="height:400px;border-radius:4px;"
                      />
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="single-flexible-slider">
                      <img
                        class="img-fluid"
                        src="/p3.png"
                        alt="gallery 03"
                        style="height:400px;border-radius:4px;"
                      />
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="single-flexible-slider">
                      <img
                        class="img-fluid"
                        src="/p4.png"
                        alt="gallery 03"
                        style="height:400px;border-radius:4px;"
                      />
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="single-flexible-slider">
                      <img
                        class="img-fluid"
                        src="/p5.png"
                        alt="gallery 03"
                        style="height:400px;border-radius:4px;"
                      />
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="single-flexible-slider">
                      <img
                        class="img-fluid"
                        src="/p6.png"
                        alt="gallery 03"
                        style="height:400px;border-radius:4px;"
                      />
                    </div>
                  </div>
                </swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container"></div>
    <!-- brand logo component -->
    <BrandLogoCarouselTwo />
  </div>
</template>

<script>
import BrandLogoCarouselTwo from "../BrandLogoCarouselTwo";
export default {
  name: "TeamAgency",
  components: {
    BrandLogoCarouselTwo,
  },
  data() {
    return {
      swiperOption: {
        spaceBetween: 30,
        loop: true,
        freeMode: true,
        slidesPerView: "auto",
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        speed: 7000,
      },
    };
  },
};
</script>
